import React, { useCallback, useMemo, useRef, useState } from 'react';
import Header from "components/Headers/Header";
import { Card, CardHeader, Container, Row, Button,Col, Label } from "reactstrap";
import { reportByDate } from "network/ApiAxiosTickets";
import DatePicker from "react-datepicker";
import * as PropTypes from 'prop-types';

import {SortingState,IntegratedSorting,PagingState,FilteringState,DataTypeProvider,SummaryState,
    IntegratedSummary, IntegratedFiltering,  IntegratedPaging,} from '@devexpress/dx-react-grid';
import {Grid,Table,TableHeaderRow, PagingPanel,TableFilterRow,TableSummaryRow,VirtualTable,Toolbar,ExportPanel, TableColumnResizing} from '@devexpress/dx-react-grid-bootstrap4';
import { GridExporter } from '@devexpress/dx-react-grid-export';
//import '@devexpress/dx-react-grid-bootstrap4/dist/dx-react-grid-bootstrap4.css';

import {saveAs} from 'file-saver';


const onSave = (workbook) => {
    workbook.xlsx.writeBuffer().then((buffer) => {
        saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'DataGrid.xlsx');
    });
};

function ReportTable() {
    const exporterRef = useRef(null);
    const startExport = useCallback(() => {
        exporterRef.current.exportGrid();
      }, [exporterRef]);
    const [data, setData] = useState();
    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState(null);
    const [pageSizes] = useState([5, 10, 15, 0]);
    const [tableColumnExtensions] = useState([
        { columnName: 'cart', wordWrapEnabled: true },
      ]);
    const [currencyColumns] = useState(['total']);
    const [currencyFilterOperations] = useState(['equal','notEqual','greaterThan','greaterThanOrEqual','lessThan','lessThanOrEqual' ]);

    const [columns] = useState([
        { name: 'Seller', title: 'Seller', align: 'center' },
        { name: 'clientName', title: 'Client', align: 'center' },
        { name: 'total', title: 'Total', align: 'center' },
        { name: 'cart', title: 'Cart', align: 'center' },
      ]);

    const [totalSummaryItems] = useState([
        { columnName: 'total', type: 'count' },
        { columnName: 'total', type: 'max' },
        { columnName: 'total', type: 'avg' },
        { columnName: 'total', type: 'sum' },
    ]);

    const [defaultColumnWidths] = useState([
        { columnName: 'Seller', width: 180 },
        { columnName: 'clientName', width: 180 },
        { columnName: 'total', width: 180 },
        { columnName: 'cart', width: 240 },
    ]);
    
    const handleOrders =async()=>{
        const resp = await reportByDate(startDate,endDate)
        if(resp.data.success){
            console.log(resp.data)
            setData(resp.data.result)
        }
    }

    const FilterIcon = ({ type }) => {
        if (type === 'month') {
            return (
            <span
                className="d-block oi oi-calendar"
            />
            );
        }
        return <TableFilterRow.Icon type={type} />;
    };

    const CurrencyEditor = ({ value, onValueChange }) => {
        const handleChange = (event) => {
        const { value: targetValue } = event.target;
        if (targetValue.trim() === '') {
        onValueChange();
        return;
        }
        onValueChange(parseInt(targetValue, 10));
        };
        return (
            <input
            className="form-control text-right"
            type="number"
            placeholder="Filter..."
            value={value === undefined ? '' : value}
            min={0}
            onChange={handleChange}
            />
        );
    };
    
    CurrencyEditor.propTypes = {
        value: PropTypes.number,
        onValueChange: PropTypes.func.isRequired,
    };
    
    CurrencyEditor.defaultProps = {
        value: undefined,
    };

    const [filteringColumnExtensions] = useState([
        {
          columnName: 'saleDate',
          predicate: (value, filter, row) => {
            if (!filter.value.length) return true;
            if (filter && filter.operation === 'month') {
              const month = parseInt(value.split('-')[1], 10);
              return month === parseInt(filter.value, 10);
            }
            return IntegratedFiltering.defaultPredicate(value, filter, row);
          },
        },
      ]);


    const handleRows = ()=>{
        /*
        return [{
            Seller:'Andre',
            clientName:'john doe',
            total:324,
            cart: '3 x heaven wjhebvejv wckjvnbv, 5 x heaven sndviejvl bhwhfe' 
        },{
            Seller:'Jonny',
            clientName:'john doe',
            total:43,
            cart: '3 x tropicana wjhebvejv wckjvnbv, 5 x tropicana sndviejvl bhwhfe' 
        }]
        */
        return data.map((data)=> {
            return {
                Seller:data.Seller.name,
                clientName:data.clientName,
                total:data.total,
                cart: data.cart.map((cartItem)=>{return cartItem.qt + ' X ' + cartItem.name + ' ' + cartItem.bottle}).toString() 
            }
        })
    }


  return (
    <>
        <Header/>
        <Container>
            <Row className='mt--6' >
                <Col>
                    <Label>From: 
                        <DatePicker
                            showTimeSelect
                            selected={startDate}
                            onChange={(date) => setStartDate(date)}
                            selectsStart
                            startDate={startDate}
                            endDate={endDate}
                        />
                    </Label>
                </Col>
                <Col>
                    <Label>Until: 
                        <DatePicker
                            showTimeSelect
                            selected={endDate}
                            onChange={(date) => setEndDate(date)}
                            selectsEnd
                            startDate={startDate}
                            endDate={endDate}
                            minDate={startDate}
                        />
                    </Label>
                </Col>
                <Col md='2'>
                    <Button className='mt-3' onClick={handleOrders} >Go</Button>
                </Col>
            </Row>
            
                {data && <><Grid 
                    rows={handleRows()}
                    columns={columns}
                >
                    <DataTypeProvider 
                    for={currencyColumns}
                    availableFilterOperations={currencyFilterOperations}
                    editorComponent={CurrencyEditor}
                    />
                    <SortingState
                    defaultSorting={[{ columnName: 'createdAt', direction: 'asc' }]}
                    />
                    <IntegratedSorting />
                    <FilteringState defaultFilters={[]} />
                    <IntegratedFiltering columnExtensions={filteringColumnExtensions} />
                    <PagingState
                    defaultCurrentPage={0}
                    defaultPageSize={5}
                    />
                    <IntegratedPaging />
                    <SummaryState
                        totalItems={totalSummaryItems}
                    />
                    <IntegratedSummary />
                    <Table  columnExtensions={tableColumnExtensions}/>
                    <TableColumnResizing defaultColumnWidths={defaultColumnWidths} />
                    {/*<VirtualTable  />*/}
                    <TableHeaderRow  showSortingControls />
                    <Toolbar />
                    <ExportPanel startExport={startExport} />
                    <TableFilterRow
                    showFilterSelector
                    iconComponent={FilterIcon}
                    messages={{ month: 'Month equals' }}
                    />
                    <TableSummaryRow />
                    <PagingPanel
                    pageSizes={pageSizes}
                    />
                </Grid>
                <GridExporter
                    ref={exporterRef}
                    rows={handleRows()}
                    columns={columns}
                    onSave={onSave}
                    totalSummaryItems={totalSummaryItems}
                />

                </>
                }
            
        </Container>
    </>
  )
}



export default ReportTable